"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _getGlobal(globalStateManager) {
    return globalStateManager.state;
}
exports.default = _getGlobal;
;
